import React, {Fragment} from 'react';
import Heading from '../componentsBange/heading/Heading';
import {isMobile} from "../utils/device";
import HeadingSeo from '../componentsBange/HeadingSeo';

class Error extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      message: "",
    }
  }

  componentDidMount() {
    const {search} = this.props.location;
    const queryStr = new URLSearchParams(search);

    let message = null;
    if (this.props.msg) {
      message = this.props.msg;
    } else if (queryStr.get("msg")) {
      message = queryStr.get("msg");
    }

    if (message) {
      this.setState({message: decodeURIComponent(message)});
    }
  }

  render() {
    return (<div ref={(ref) => {
        this.container = ref;
      }} fluid className="d-flex main-content-container container-fluid">
        <div className={"row"} style={{flex: "1 1", background: "white"}}>
          <div className={"col-12 pt-3"}>
            <HeadingSeo type="secondary" headingPriority={1}>Fehler</HeadingSeo>
            {this.state.message &&
              <div>{this.state.message}</div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Error
